import { MODULE } from '@core/configs';
import { environment } from '@environments/environment';

export const APP_CONFIG = {
  module: MODULE.careconneConsole,
  apiBaseUrl: environment.apiBaseUrl,
  tokenUrl: environment.tokenUrl,
  inActiveTime: 30,
};
